<template>
  <div
    :style="{
      backgroundColor: section.styles.backgroundColor || '#f8fafc',
      padding: section.styles.padding || '60px 20px',
      textAlign: section.styles.textAlign || 'center',
    }"
  >
    <div class="max-w-5xl mx-auto">
      <h2 v-if="section.content.title" class="text-3xl font-bold text-gray-900 mb-10">{{ section.content.title }}</h2>
      <div class="grid gap-6 md:grid-cols-2">
        <blockquote
          v-for="(item, index) in section.content.items || []"
          :key="index"
          class="rounded-xl border border-gray-200 bg-white p-6 text-left shadow-sm"
        >
          <p class="text-gray-700 leading-relaxed mb-4">“{{ item.quote }}”</p>
          <footer class="text-sm">
            <div class="font-semibold text-gray-900">{{ item.author }}</div>
            <div class="text-gray-500">{{ item.role }}</div>
          </footer>
        </blockquote>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    section: { type: Object, required: true },
    preview: { type: Boolean, default: false },
  },
}
</script>
